import React, { useEffect, useState, useRef } from "react";
import NotificationSound from "notification/sound.mp3";
import { useSelector, useDispatch } from "react-redux";
import useCopyToClipboard from "hooks/useCopyToClipboard";
import { FaCopy } from "react-icons/fa6";
import {
  orderFinalize,
  reset,
} from "redux/reseller/orders/ordersSlice";
import OrderIndicator from "components/OrderIndicator";
import Loader from "components/Loader";
import moment from "moment";
import "moment/locale/tr";
import { toast } from "react-toastify";

moment.locale("tr");

const Orders = ({ data, filter, search, onFilterChange, onSearchChange, isLoading, onRefresh }) => {
  const audioRef = useRef();
  const dispatch = useDispatch();
  const [isCopied, copy] = useCopyToClipboard();
  const { isFinalizeSuccess, isFinalizeError, isFinalizeLoading, message } =
    useSelector((state) => state.resellerOrders);
  const [prevOrderCount, setPrevOrderCount] = useState(null);
  const { profile } = useSelector((state) => state.resellerProfile);

  useEffect(() => {
    if (prevOrderCount !== null && data?.length > prevOrderCount) {
      audioRef.current.play();
    }
    setPrevOrderCount(data?.length);
  }, [data, prevOrderCount]);

  useEffect(() => {
    if (isFinalizeSuccess) {
      toast.success("İşlem başarıyla tamamlandı");
      // Refresh data without page reload
      if (onRefresh) {
        onRefresh();
      }
      dispatch(reset());
    }
    if (isFinalizeError) {
      toast.error(message);
      dispatch(reset());
    }
  }, [isFinalizeSuccess, isFinalizeError, onRefresh, dispatch]);

  useEffect(() => {
    if (isCopied === true) {
      toast.success("Kullanıcı ID Kopyalandı", { autoClose: 3000 });
    }
  }, [isCopied]);

  const handleSearchChange = (event) => {
    onSearchChange(event.target.value);
  };

  const handleFinalize = (id, status) => {
    dispatch(orderFinalize({ order_id: id, status: status }));
  };

  const OrderCard = ({ item }) => (
    <div className={`bg-gray-900 flex flex-col p-3 relative text-white-100 rounded-md ${
      item?.retailreseller_id && 'border-2 border-primary'
    }`}>
      <h2>Ad Soyad: {item.payment.full_name}</h2>
      <h2>
        Kullanıcı ID: {item.bigo_username}{' '}
        <FaCopy
          onClick={() => copy(item.bigo_username)}
          className="inline cursor-pointer"
          size={14}
        />
      </h2>
      <h2>Yatırılan Tutar: {item.payment.amount_try} ₺</h2>
      <h2>Elmas Miktarı: {item.amount_diamonds}</h2>
      {item.message && <h2>Ek Bilgi: {item.message}</h2>}
      {item.payment.reference1 && <h2>Sorgu No: {item.payment.reference1}</h2>}
      {(item.subreseller !== null || (item?.retailreseller !== null && profile.id !== item?.retailreseller_id)) && (
        <h2>
          Bayi: {item.subreseller !== null && item.subreseller.name}
          {item?.retailreseller !== null && profile.id !== item?.retailreseller_id &&
            ` (Perakende: ${item?.retailreseller?.name})`}
        </h2>
      )}
      <h2>İşlem Tarihi: {moment(item.created_at).format("LLL")}</h2>
      <div className="absolute right-2 top-2">
        {item.status === "completed" ? (
          <OrderIndicator color="green">Tamamlandı</OrderIndicator>
        ) : item.status === "pending" ? (
          <OrderIndicator color="yellow">Bekliyor</OrderIndicator>
        ) : item.status === "failed" ? (
          <OrderIndicator color="red">Reddedildi</OrderIndicator>
        ) : (
          <OrderIndicator color="red">Bilinmiyor</OrderIndicator>
        )}
      </div>
      {filter === "pending" && (
        <div className="flex mt-4 gap-2">
          <div
            onClick={() => handleFinalize(item.id, "completed")}
            className="text-white-100 cursor-pointer bg-primary px-2 py-2 flex items-center justify-center w-full"
          >
            Onayla
          </div>
          {item?.retailreseller !== null && profile.id !== item?.retailreseller_id && (
            <div
              onClick={() => handleFinalize(item.id, "failed")}
              className="text-white-100 cursor-pointer bg-red-600 px-2 py-2 flex items-center justify-center w-full"
            >
              Reddet
            </div>
          )}
        </div>
      )}
    </div>
  );

  return (
    <>
      <audio ref={audioRef} src={NotificationSound} />
      
      <div className="flex flex-col md:flex-row md:justify-between px-4 pb-4">
        <input
          type="text"
          className="px-2 py-1 rounded-md"
          placeholder="Kullanıcı Ara"
          value={search || ""}
          onChange={handleSearchChange}
        />
        <div className="mx-4 mt-4 md:mt-0 text-white-100">
          <div className="flex gap-2 justify-between">
            <div
              onClick={() => onFilterChange("pending")}
              className="bg-yellow-50 text-yellow-800 px-2 py-1 rounded-md cursor-pointer"
            >
              Onay Bekleyenler
            </div>
            <div
              onClick={() => onFilterChange("completed")}
              className="bg-green-50 text-green-700 rounded-md px-2 py-1 cursor-pointer"
            >
              Onaylananlar
            </div>
          </div>
        </div>
      </div>

      {isLoading ? (
        <Loader />
      ) : !data || data.length === 0 ? (
        <div className="text-center text-white-100 py-8">
          Gösterilecek sipariş bulunmuyor
        </div>
      ) : (
        <div className="overflow-x-auto p-4 grid grid-cols-1 md:grid-cols-4 gap-4">
          {data.map((item) => (
            <OrderCard key={item.id} item={item} />
          ))}
        </div>
      )}
    </>
  );
};

export default Orders;